
<div class="w-full h-4 flex flex-row justify-content-between align-items-center p-3 splash-bg">

  <div class="w-4rem"></div>


  <img class="align-self-center cursor-pointer" [routerLink]="['/']" src="assets/icons/logo_full.svg" style="width:130px; height:37px;fill: white;">

  <div class="inline-block">
    <p-menu #LocaleMenu [model]="languages" [popup]="true"></p-menu>
    <p-button
      styleClass="border-1 border-round-2xl p-button-outlined p-button-secondary border-gray-100 font-light text-sm text-white"
      type="button"
      (click)="LocaleMenu.toggle($event)" icon="pi pi-angle-down"
      iconPos="right" label="{{articlesService.isEnglish?'En':'Ar'}}"></p-button>
  </div>

</div>
